<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { defineProps, defineEmits, reactive, ref, onMounted, computed } from "vue";

const props = defineProps({
    title: { type: String, required: true },
    loading: Boolean,
    items: { type: Object, required: true }
});
const minimized = ref(true);
</script>
<template>
    <div class="s20 widget px-6 pt-8 pb-2">
        <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
            <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                {{ props.title }}
            </span>
        </div>
        <div class="s10 mt--5-5 flex-right gap-4">
            <slot name="action" />
        </div>

        <div class="s20 items-center gap-6 px-5 pb-4 collapse-content active">
            <div class="clear-both h-10"></div>
            <slot name="header" />
            <div class="clear-both h-30"></div>

            <div v-if="loading" class="text-center py-5 text-grey-500">
                Chargement des éléments...
            </div>

            <div v-else-if="items.length === 0" class="text-center py-5 text-grey-500">
                Aucun élément disponible
            </div>

            <div class="grid4 px-1">
                <template v-for="item in items.slice(0, 12)" :key="item.id">
                    <slot name="item" :item="item" />
                </template>
            </div>
                
            <div class="clear-both h-20"></div>
            <div :class="{'collapse-content': minimized}">
                <div class="grid4 px-1">
                    <template v-for="item in items.slice(12)" :key="item.id">
                        <slot name="item" :item="item" />
                    </template>
                </div>
            </div>
            <div class="clear-both h-15"></div>
            <span class="px-5 py-4 bg-color rounded-100 font-bold text-lg collapse-open align-right" :class="{'active': !minimized}" @click="minimized = !minimized" v-if="items.length > 12">
                <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                Voir tous
            </span>
        </div>

    </div>
</template>